import { LucideIcon } from 'lucide-react';

export interface StatusColor {
  bg: string;
  text: string;
  border: string;
}

export const STATUS_COLORS: Record<string, StatusColor> = {
  active: { bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-200' },
  pending: { bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-200' },
  completed: { bg: 'bg-sky-100', text: 'text-sky-800', border: 'border-sky-200' },
  cancelled: { bg: 'bg-rose-100', text: 'text-rose-800', border: 'border-rose-200' },
  overdue: { bg: 'bg-rose-100', text: 'text-rose-800', border: 'border-rose-200' },
  scheduled: { bg: 'bg-sky-100', text: 'text-sky-800', border: 'border-sky-200' },
  confirmed: { bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-200' },
  paid: { bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-200' },
  unpaid: { bg: 'bg-rose-100', text: 'text-rose-800', border: 'border-rose-200' },
  default: { bg: 'bg-gray-100', text: 'text-gray-800', border: 'border-gray-200' },
};

export type TrendType = 'up' | 'down' | 'neutral';

export interface SummaryCardData {
  id?: string;
  title: string;
  subtitle?: string;
  value?: number;
  target?: number;
  trend?: TrendType;
  trendValue?: string;
  status?: string;
}

export type ColumnType = 'text' | 'status' | 'currency' | 'date';

export interface ReportColumn {
  key: string;
  label: string;
  type?: ColumnType;
  className?: string;
}

export interface ReportSection {
  id?: string;
  title: string;
  type: string; // Used for icon mapping
  data: Record<string, any>[];
  columns: ReportColumn[];
  maxItems?: number;
  showViewAll?: boolean;
}

export type SectionIconMap = Record<string, LucideIcon>;
